(function() {

dmx.Formatters('string', {

    // startWith(search:String):Boolean
    startsWith: function(string, search) {
        return string.indexOf(search) === 0;
    },

    // endsWith(search:String):Boolean
    endsWith: function(string, search) {
        var pos = string.length - search.length;
        var index = string.lastIndexOf(search);
        return index !== -1 && index === pos;
    },

    // contains(search:String):Boolean
    contains: function(string, search) {
        return string.indexOf(search) !== -1;
    },

    // notContains(search:String):Boolean
    notContains: function(string, search) {
        return string.indexOf(search) === -1;
    },

    search: function(string, search, matchAll) {
        return String(search).split(/\s+/)[matchAll ? 'every' : 'some'](function(word) {
            return string.indexOf(word) !== -1;
        });
    },

    // fuzzySearch(search:String):Boolean
    fuzzySearch: function(string, search) {
        var stringLen = string.length;
        var searchLen = search.length;
        if (searchLen > stringLen) {
            return false;
        }
        if (searchLen === stringLen) {
            return string === search;
        }
        outer: for (var i = 0, j = 0; i < searchLen; i++) {
            var char = search.charCodeAt(i);
            while (j < stringLen) {
                if (string.charCodeAt(j++) === char) {
                    continue outer;
                }
            }
            return false;
        }
        return true;
    },

    // test(regexp:RegExp):Boolean
    test: function(string, regexp) {
        return regexp.test(string);
    },

    // lowercase():String
    lowercase: function(string) {
        return string.toLowerCase();
    },

    // uppercase():String
    uppercase: function(string) {
        return string.toUpperCase();
    },

    // slugify():String
    slugify: function(string) {
        var map = {"2d":"-","20":"-","24":"s","26":"and","30":"0","31":"1","32":"2","33":"3","34":"4","35":"5","36":"6","37":"7","38":"8","39":"9","41":"A","42":"B","43":"C","44":"D","45":"E","46":"F","47":"G","48":"H","49":"I","50":"P","51":"Q","52":"R","53":"S","54":"T","55":"U","56":"V","57":"W","58":"X","59":"Y","61":"a","62":"b","63":"c","64":"d","65":"e","66":"f","67":"g","68":"h","69":"i","70":"p","71":"q","72":"r","73":"s","74":"t","75":"u","76":"v","77":"w","78":"x","79":"y","100":"A","101":"a","102":"A","103":"a","104":"A","105":"a","106":"C","107":"c","108":"C","109":"c","110":"D","111":"d","112":"E","113":"e","114":"E","115":"e","116":"E","117":"e","118":"E","119":"e","120":"G","121":"g","122":"G","123":"g","124":"H","125":"h","126":"H","127":"h","128":"I","129":"i","130":"I","131":"i","132":"IJ","133":"ij","134":"J","135":"j","136":"K","137":"k","138":"k","139":"L","140":"l","141":"L","142":"l","143":"N","144":"n","145":"N","146":"n","147":"N","148":"n","149":"n","150":"O","151":"o","152":"OE","153":"oe","154":"R","155":"r","156":"R","157":"r","158":"R","159":"r","160":"S","161":"s","162":"T","163":"t","164":"T","165":"t","166":"T","167":"t","168":"U","169":"u","170":"U","171":"u","172":"U","173":"u","174":"W","175":"w","176":"Y","177":"y","178":"Y","179":"Z","180":"b","181":"B","182":"b","183":"b","184":"b","185":"b","186":"C","187":"C","188":"c","189":"D","190":"E","191":"F","192":"f","193":"G","194":"Y","195":"h","196":"i","197":"I","198":"K","199":"k","200":"A","201":"a","202":"A","203":"a","204":"E","205":"e","206":"E","207":"e","208":"I","209":"i","210":"R","211":"r","212":"R","213":"r","214":"U","215":"u","216":"U","217":"u","218":"S","219":"s","220":"n","221":"d","222":"8","223":"8","224":"Z","225":"z","226":"A","227":"a","228":"E","229":"e","230":"O","231":"o","232":"Y","233":"y","234":"l","235":"n","236":"t","237":"j","238":"db","239":"qp","240":"<","241":"?","242":"?","243":"B","244":"U","245":"A","246":"E","247":"e","248":"J","249":"j","250":"a","251":"a","252":"a","253":"b","254":"c","255":"e","256":"d","257":"d","258":"e","259":"e","260":"g","261":"g","262":"g","263":"Y","264":"x","265":"u","266":"h","267":"h","268":"i","269":"i","270":"w","271":"m","272":"n","273":"n","274":"N","275":"o","276":"oe","277":"m","278":"o","279":"r","280":"R","281":"R","282":"S","283":"f","284":"f","285":"f","286":"f","287":"t","288":"t","289":"u","290":"Z","291":"Z","292":"3","293":"3","294":"?","295":"?","296":"5","297":"C","298":"O","299":"B","363":"a","364":"e","365":"i","366":"o","367":"u","368":"c","369":"d","386":"A","388":"E","389":"H","390":"i","391":"A","392":"B","393":"r","394":"A","395":"E","396":"Z","397":"H","398":"O","399":"I","400":"E","401":"E","402":"T","403":"r","404":"E","405":"S","406":"I","407":"I","408":"J","409":"jb","410":"A","411":"B","412":"V","413":"G","414":"D","415":"E","416":"ZH","417":"Z","418":"I","419":"Y","420":"R","421":"S","422":"T","423":"U","424":"F","425":"H","426":"TS","427":"CH","428":"SH","429":"SCH","430":"a","431":"b","432":"v","433":"g","434":"d","435":"e","436":"zh","437":"z","438":"i","439":"y","440":"r","441":"s","442":"t","443":"u","444":"f","445":"h","446":"ts","447":"ch","448":"sh","449":"sch","450":"e","451":"e","452":"h","453":"r","454":"e","455":"s","456":"i","457":"i","458":"j","459":"jb","460":"W","461":"w","462":"Tb","463":"tb","464":"IC","465":"ic","466":"A","467":"a","468":"IA","469":"ia","470":"Y","471":"y","472":"O","473":"o","474":"V","475":"v","476":"V","477":"v","478":"Oy","479":"oy","480":"C","481":"c","490":"R","491":"r","492":"F","493":"f","494":"H","495":"h","496":"X","497":"x","498":"3","499":"3","500":"d","501":"d","502":"d","503":"d","504":"R","505":"R","506":"R","507":"R","508":"JT","509":"JT","510":"E","511":"e","512":"JT","513":"jt","514":"JX","515":"JX","531":"U","532":"D","533":"Q","534":"N","535":"T","536":"2","537":"F","538":"r","539":"p","540":"z","541":"2","542":"n","543":"x","544":"U","545":"B","546":"j","547":"t","548":"n","549":"C","550":"R","551":"8","552":"R","553":"O","554":"P","555":"O","556":"S","561":"w","562":"f","563":"q","564":"n","565":"t","566":"q","567":"t","568":"n","569":"p","570":"h","571":"a","572":"n","573":"a","574":"u","575":"j","576":"u","577":"2","578":"n","579":"2","580":"n","581":"g","582":"l","583":"uh","584":"p","585":"o","586":"S","587":"u","4a":"J","4b":"K","4c":"L","4d":"M","4e":"N","4f":"O","5a":"Z","6a":"j","6b":"k","6c":"l","6d":"m","6e":"n","6f":"o","7a":"z","a2":"c","a3":"f","a5":"Y","a7":"s","a9":"c","aa":"a","ae":"r","b2":"2","b3":"3","b5":"u","b6":"p","b9":"1","c0":"A","c1":"A","c2":"A","c3":"A","c4":"A","c5":"A","c6":"AE","c7":"C","c8":"E","c9":"E","ca":"E","cb":"E","cc":"I","cd":"I","ce":"I","cf":"I","d0":"D","d1":"N","d2":"O","d3":"O","d4":"O","d5":"O","d6":"O","d7":"X","d8":"O","d9":"U","da":"U","db":"U","dc":"U","dd":"Y","de":"p","df":"b","e0":"a","e1":"a","e2":"a","e3":"a","e4":"a","e5":"a","e6":"ae","e7":"c","e8":"e","e9":"e","ea":"e","eb":"e","ec":"i","ed":"i","ee":"i","ef":"i","f0":"o","f1":"n","f2":"o","f3":"o","f4":"o","f5":"o","f6":"o","f8":"o","f9":"u","fa":"u","fb":"u","fc":"u","fd":"y","ff":"y","10a":"C","10b":"c","10c":"C","10d":"c","10e":"D","10f":"d","11a":"E","11b":"e","11c":"G","11d":"g","11e":"G","11f":"g","12a":"I","12b":"i","12c":"I","12d":"i","12e":"I","12f":"i","13a":"l","13b":"L","13c":"l","13d":"L","13e":"l","13f":"L","14a":"n","14b":"n","14c":"O","14d":"o","14e":"O","14f":"o","15a":"S","15b":"s","15c":"S","15d":"s","15e":"S","15f":"s","16a":"U","16b":"u","16c":"U","16d":"u","16e":"U","16f":"u","17a":"z","17b":"Z","17c":"z","17d":"Z","17e":"z","17f":"f","18a":"D","18b":"d","18c":"d","18d":"q","18e":"E","18f":"e","19a":"l","19b":"h","19c":"w","19d":"N","19e":"n","19f":"O","1a0":"O","1a1":"o","1a2":"P","1a3":"P","1a4":"P","1a5":"p","1a6":"R","1a7":"S","1a8":"s","1a9":"E","1aa":"l","1ab":"t","1ac":"T","1ad":"t","1ae":"T","1af":"U","1b0":"u","1b1":"U","1b2":"U","1b3":"Y","1b4":"y","1b5":"Z","1b6":"z","1b7":"3","1b8":"3","1b9":"3","1ba":"3","1bb":"2","1bc":"5","1bd":"5","1be":"5","1bf":"p","1c4":"DZ","1c5":"Dz","1c6":"dz","1c7":"Lj","1c8":"Lj","1c9":"lj","1ca":"NJ","1cb":"Nj","1cc":"nj","1cd":"A","1ce":"a","1cf":"I","1d0":"i","1d1":"O","1d2":"o","1d3":"U","1d4":"u","1d5":"U","1d6":"u","1d7":"U","1d8":"u","1d9":"U","1da":"u","1db":"U","1dc":"u","1dd":"e","1de":"A","1df":"a","1e0":"A","1e1":"a","1e2":"AE","1e3":"ae","1e4":"G","1e5":"g","1e6":"G","1e7":"g","1e8":"K","1e9":"k","1ea":"Q","1eb":"q","1ec":"Q","1ed":"q","1ee":"3","1ef":"3","1f0":"J","1f1":"dz","1f2":"dZ","1f3":"DZ","1f4":"g","1f5":"G","1f6":"h","1f7":"p","1f8":"N","1f9":"n","1fa":"A","1fb":"a","1fc":"AE","1fd":"ae","1fe":"O","1ff":"o","20a":"I","20b":"i","20c":"O","20d":"o","20e":"O","20f":"o","21a":"T","21b":"t","21c":"3","21d":"3","21e":"H","21f":"h","22a":"O","22b":"o","22c":"O","22d":"o","22e":"O","22f":"o","23a":"A","23b":"C","23c":"c","23d":"L","23e":"T","23f":"s","24a":"Q","24b":"q","24c":"R","24d":"r","24e":"Y","24f":"y","25a":"e","25b":"3","25c":"3","25d":"3","25e":"3","25f":"j","26a":"i","26b":"I","26c":"I","26d":"I","26e":"h","26f":"w","27a":"R","27b":"r","27c":"R","27d":"R","27e":"r","27f":"r","28a":"u","28b":"v","28c":"A","28d":"M","28e":"Y","28f":"Y","29a":"B","29b":"G","29c":"H","29d":"j","29e":"K","29f":"L","2a0":"q","2a1":"?","2a2":"c","2a3":"dz","2a4":"d3","2a5":"dz","2a6":"ts","2a7":"tf","2a8":"tc","2a9":"fn","2aa":"ls","2ab":"lz","2ac":"ww","2ae":"u","2af":"u","2b0":"h","2b1":"h","2b2":"j","2b3":"r","2b4":"r","2b5":"r","2b6":"R","2b7":"W","2b8":"Y","2df":"x","2e0":"Y","2e1":"1","2e2":"s","2e3":"x","2e4":"c","36a":"h","36b":"m","36c":"r","36d":"t","36e":"v","36f":"x","37b":"c","37c":"c","37d":"c","38a":"I","38c":"O","38e":"Y","38f":"O","39a":"K","39b":"A","39c":"M","39d":"N","39e":"E","39f":"O","3a0":"TT","3a1":"P","3a3":"E","3a4":"T","3a5":"Y","3a6":"O","3a7":"X","3a8":"Y","3a9":"O","3aa":"I","3ab":"Y","3ac":"a","3ad":"e","3ae":"n","3af":"i","3b0":"v","3b1":"a","3b2":"b","3b3":"y","3b4":"d","3b5":"e","3b6":"c","3b7":"n","3b8":"0","3b9":"1","3ba":"k","3bb":"j","3bc":"u","3bd":"v","3be":"c","3bf":"o","3c0":"tt","3c1":"p","3c2":"s","3c3":"o","3c4":"t","3c5":"u","3c6":"q","3c7":"X","3c8":"Y","3c9":"w","3ca":"i","3cb":"u","3cc":"o","3cd":"u","3ce":"w","3d0":"b","3d1":"e","3d2":"Y","3d3":"Y","3d4":"Y","3d5":"O","3d6":"w","3d7":"x","3d8":"Q","3d9":"q","3da":"C","3db":"c","3dc":"F","3dd":"f","3de":"N","3df":"N","3e2":"W","3e3":"w","3e4":"q","3e5":"q","3e6":"h","3e7":"e","3e8":"S","3e9":"s","3ea":"X","3eb":"x","3ec":"6","3ed":"6","3ee":"t","3ef":"t","3f0":"x","3f1":"e","3f2":"c","3f3":"j","3f4":"O","3f5":"E","3f6":"E","3f7":"p","3f8":"p","3f9":"C","3fa":"M","3fb":"M","3fc":"p","3fd":"C","3fe":"C","3ff":"C","40a":"Hb","40b":"Th","40c":"K","40d":"N","40e":"Y","40f":"U","41a":"K","41b":"L","41c":"M","41d":"N","41e":"O","41f":"P","42a":"","42b":"Y","42c":"","42d":"E","42e":"U","42f":"YA","43a":"k","43b":"l","43c":"m","43d":"n","43e":"o","43f":"p","44a":"","44b":"y","44c":"","44d":"e","44e":"u","44f":"ya","45a":"Hb","45b":"h","45c":"k","45d":"n","45e":"y","45f":"u","46a":"mY","46b":"my","46c":"Im","46d":"Im","46e":"3","46f":"3","47a":"O","47b":"o","47c":"W","47d":"w","47e":"W","47f":"W","48a":"H","48b":"H","48c":"B","48d":"b","48e":"P","48f":"p","49a":"K","49b":"k","49c":"K","49d":"k","49e":"K","49f":"k","4a0":"K","4a1":"k","4a2":"H","4a3":"h","4a4":"H","4a5":"h","4a6":"Ih","4a7":"ih","4a8":"O","4a9":"o","4aa":"C","4ab":"c","4ac":"T","4ad":"t","4ae":"Y","4af":"y","4b0":"Y","4b1":"y","4b2":"X","4b3":"x","4b4":"TI","4b5":"ti","4b6":"H","4b7":"h","4b8":"H","4b9":"h","4ba":"H","4bb":"h","4bc":"E","4bd":"e","4be":"E","4bf":"e","4c0":"I","4c1":"X","4c2":"x","4c3":"K","4c4":"k","4c5":"jt","4c6":"jt","4c7":"H","4c8":"h","4c9":"H","4ca":"h","4cb":"H","4cc":"h","4cd":"M","4ce":"m","4cf":"l","4d0":"A","4d1":"a","4d2":"A","4d3":"a","4d4":"AE","4d5":"ae","4d6":"E","4d7":"e","4d8":"e","4d9":"e","4da":"E","4db":"e","4dc":"X","4dd":"X","4de":"3","4df":"3","4e0":"3","4e1":"3","4e2":"N","4e3":"n","4e4":"N","4e5":"n","4e6":"O","4e7":"o","4e8":"O","4e9":"o","4ea":"O","4eb":"o","4ec":"E","4ed":"e","4ee":"Y","4ef":"y","4f0":"Y","4f1":"y","4f2":"Y","4f3":"y","4f4":"H","4f5":"h","4f6":"R","4f7":"r","4f8":"bI","4f9":"bi","4fa":"F","4fb":"f","4fc":"X","4fd":"x","4fe":"X","4ff":"x","50a":"H","50b":"h","50c":"G","50d":"g","50e":"T","50f":"t","51a":"Q","51b":"q","51c":"W","51d":"w","53a":"d","53b":"r","53c":"L","53d":"Iu","53e":"O","53f":"y","54a":"m","54b":"o","54c":"N","54d":"U","54e":"Y","54f":"S","56a":"d","56b":"h","56c":"l","56d":"lu","56e":"d","56f":"y","57a":"w","57b":"2","57c":"n","57d":"u","57e":"y","57f":"un"};

        var str = '';
        for (var i = 0; i < string.length; i++) {
          str += map[string.charCodeAt(i).toString(16)] || '';
        }

        return str.toLowerCase().replace(/-+/g, '-').replace(/^-|-$/, '');
    },

    // camelize():String
    camelize: function(string) {
        return string.trim().replace(/(\-|_|\s)+(.)?/g, function(a, b, c) {
            return (c ? c.toUpperCase() : '');
        });
    },

    // capitalize():String
    capitalize: function(string) {
        return string.substr(0, 1).toUpperCase() + string.substr(1).toLowerCase();
    },

    // dasherize():String
    dasherize: function(string) {
        return string.replace(/[_\s]+/g, '-').replace(/([A-Z])/g, '-$1').replace(/-+/g, '-').toLowerCase();
    },

    // humanize():String
    humanize: function(string) {
        var str = string.replace(/([a-z\d])([A-Z+])/g, '$1_$2').replace(/[-\s]+/g, '_').replace(/_+/g, ' ').trim();
        return str.substr(0, 1).toUpperCase() + str.substr(1).toLowerCase();
    },

    // underscore():String
    underscore: function(string) {
        return string.trim().replace(/([a-z\d])([A-Z]+)/g, '$1_$1').replace(/[-\s]+/g, '_').toLowerCase();
    },

    // titlecase():String
    titlecase: function(string) {
        return string.replace(/(?:^|\s)\S/g, function(a) {
            return a.toUpperCase();
        });
    },

    // camelcase():String
    camelcase: function(string) {
        return string.toLowerCase().replace(/\s+(\S)/g, function(a, b) {
            return b.toUpperCase();
        });
    },

    // substr(start:Number, [length:Number]):String
    substr: function(string, start, length) {
        return string.substr(start, length);
    },

    // substring(start:Number, [end:Number]):String
    substring: function(string, start, end) {
        return string.substring(start, end);
    },

    // replace(search:String|RegExp, replace:String):String
    replace: function(string, search, replace) {
        if (typeof search == 'string') {
            search = new RegExp(dmx.escapeRegExp(search), 'g');
        }
        return string.replace(search, replace);
    },

    // trim():String
    trim: function(string) {
        return string.trim();
    },

    // trimLeft():String
    trimLeft: function(string) {
        return string.replace(/^[\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF]*/, '');
    },

    // trimRight():String
    trimRight: function(string) {
        return string.replace(/[\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF]*$/, '');
    },

    // concat(string2:String):String
    concat: function(string, string2) {
        return string.concat(string2);
    },

    // trunc(charsAllowed:Number, [useWordBoundary:Boolean], [append:String]):String
    trunc: function(string, charsAllowed, useWordBoundary, append) {
        useWordBoundary = !!useWordBoundary;
        append = append || '…';

        if (string.length > charsAllowed) {
            string = string.substr(0, charsAllowed);

            if (useWordBoundary && string.indexOf(' ') !== -1) {
                string = string.substr(0, string.lastIndexOf(' '));
            }

            string += append;
        }

        return string;
    },

    // stripTags():String
    stripTags: function(string) {
        return string.replace(/<[^>]+>/g, '');
    },

    // padStart(length:Number, [filler:String]):String
    padStart: function(string, length, filler) {
        filler = filler || ' ';

        if (length <= string.length) {
            return string;
        }

        var rem = length - string.length;
        while (filler.length < rem) {
            filler += filler;
        }

        return filler.substr(0, rem) + string;
    },

    // padEnd(length:Number, [filler:String]):String
    padEnd: function(string, length, filler) {
        filler = filler || ' ';

        if (length <= string.length) {
            return string;
        }

        var rem = length - string.length;
        while (filler.length < rem) {
            filler += filler;
        }

        return string + filler.substr(0, rem);
    },

    // repeat(count:Number):String
    repeat: function(string, count) {
        var out = '';
        for (var i = 0; i < count; i++) {
            out += string;
        }
        return out;
    },

    // wordCount():Number
    wordCount: function(string) {
        return string.trim().split(/\s+/).length;
    },

    // length():Number
    length: function(string) {
        return string.length;
    },

    // split(separator:String|RegExp):Array
    split: function(string, separator) {
        return string.split(separator);
    },

    // default()
    default: function(string) {
        return string;
    },

    // toNumber():Number
    toNumber: function(string) {
        return Number(string);
    },

    // Date formatters (requires a date string)

    toDate: function(string) {
        var date = parseDate(string);
        if (date.toString() == 'Invalid Date') return null;
        return formatLocalDate(date);
    },

    toUTCDate: function(string) {
        var date = parseDate(string);
        if (date.toString() == 'Invalid Date') return null;
        return date.toISOString();
    },

    // getYear():Number
    getYear: function(string) {
        var date = parseDate(string);
        if (date.toString() == 'Invalid Date') return null;
        return date.getFullYear();
    },

    // getMonth():Number
    getMonth: function(string) {
        var date = parseDate(string);
        if (date.toString() == 'Invalid Date') return null;
        return date.getMonth();
    },

    // getDate():Number
    getDate: function(string) {
        var date = parseDate(string);
        if (date.toString() == 'Invalid Date') return null;
        return date.getDate();
    },

    // getDay():Number
    getDay: function(string) {
        var date = parseDate(string);
        if (date.toString() == 'Invalid Date') return null;
        return date.getDay();
    },

    // addYears(years:Number):String
    addYears: function(string, years) {
        var date = parseDate(string);
        if (date.toString() == 'Invalid Date') return null;
        date.setFullYear(date.getFullYear() + years);
        return formatLocalDate(date);
    },

    // addMonths(months:Number):String
    addMonths: function(string, months) {
        var date = parseDate(string);
        if (date.toString() == 'Invalid Date') return null;
        date.setMonth(date.getMonth() + months);
        return formatLocalDate(date);
    },

    // addWeeks(weeks:Number):String
    addWeeks: function(string, weeks) {
        var date = parseDate(string);
        if (date.toString() == 'Invalid Date') return null;
        date.setDate(date.getDate() + (weeks * 7));
        return formatLocalDate(date);
    },

    // addDays(days:Number):String
    addDays: function(string, days) {
        var date = parseDate(string);
        if (date.toString() == 'Invalid Date') return null;
        date.setDate(date.getDate() + days);
        return formatLocalDate(date);
    },

    // addHours(hours:Number):String
    addHours: function(string, hours) {
        var date = parseDate(string);
        if (date.toString() == 'Invalid Date') return null;
        date.setHours(date.getHours() + hours);
        return formatLocalDate(date);
    },

    // addMinutes(minutes:Number):String
    addMinutes: function(string, minutes) {
        var date = parseDate(string);
        if (date.toString() == 'Invalid Date') return null;
        date.setMinutes(date.getMinutes() + minutes);
        return formatLocalDate(date);
    },

    // addSeconds(seconds:Number):String
    addSeconds: function(string, seconds) {
        var date = parseDate(string);
        if (date.toString() == 'Invalid Date') return null;
        date.setSeconds(date.getSeconds() + seconds);
        return formatLocalDate(date);
    },

    // yearsUntil(date:String):Number
    yearsUntil: function(string, date) {
        var date1 = parseDate(string);
        var date2 = parseDate(date);
        if (date1.toString() == 'Invalid' || date2.toString() == 'Invalid') return null;
        return date2.getFullYear() - date1.getFullYear();
    },

    // monthsUntil(date:String):Number
    monthsUntil: function(string, date) {
        var date1 = parseDate(string);
        var date2 = parseDate(date);
        if (date1.toString() == 'Invalid' || date2.toString() == 'Invalid') return null;
        return (date2.getFullYear() * 12 + date2.getMonth()) - (date1.getFullYear() * 12 + date1.getMonth());
    },

    // weeksUntil(date:String):Number
    weeksUntil: function(string, date) {
        var date1 = parseDate(string);
        var date2 = parseDate(date);
        if (date1.toString() == 'Invalid' || date2.toString() == 'Invalid') return null;
        return Math.floor((date2 - date1) / 604800000); // 7 * 24 * 60 * 60 * 1000
    },

    // daysUntil(date:String):Number
    daysUntil: function(string, date) {
        var date1 = resetTime(parseDate(string));
        var date2 = resetTime(parseDate(date));
        if (date1.toString() == 'Invalid' || date2.toString() == 'Invalid') return null;
        return Math.round((date2 - date1) / 86400000); // 24 * 60 * 60 * 1000
    },

    // hoursUntil(date:String):Number
    hoursUntil: function(string, date) {
        var date1 = parseDate(string);
        var date2 = parseDate(date);
        if (date1.toString() == 'Invalid' || date2.toString() == 'Invalid') return null;
        return Math.floor((date2 - date1) / 3600000); // 60 * 60 * 1000
    },

    // minutesUntil(date:String):Number
    minutesUntil: function(string, date) {
        var date1 = parseDate(string);
        var date2 = parseDate(date);
        if (date1.toString() == 'Invalid' || date2.toString() == 'Invalid') return null;
        return Math.floor((date2 - date1) / 60000); // 60 * 1000
    },

    // secondsUntil(date:String):Number
    secondsUntil: function(string, date) {
        var date1 = parseDate(string);
        var date2 = parseDate(date);
        if (date1.toString() == 'Invalid' || date2.toString() == 'Invalid') return null;
        return Math.floor((date2 - date1) / 1000);
    },

    // timeUntil(date:String, [includeHours:Boolean]):String
    timeUntil: function(string, date, includeHours) {
        var pad = function(n) { return (n < 10 ? '0' : '') + n; };
        var date1 = parseDate(string);
        var date2 = parseDate(date);
        if (date1.toString() == 'Invalid' || date2.toString() == 'Invalid') return null;
        var seconds = Math.floor((date2 - date1) / 1000);
        var minutes = Math.floor(seconds / 60);
        var hours = Math.floor(minutes / 60);
        seconds -= minutes * 60;
        if (includeHours) {
            minutes -= hours * 60;
            return pad(hours) + ':' + pad(minutes) + ':' + pad(seconds);
        }
        return pad(minutes) + ':' + pad(seconds);
    },

    toISODate: function(string) {
        var date = parseDate(string);
        if (date.toString() == 'Invalid Date') return null;
        var pad2 = function(n) { return ('00' + n).substr(-2); };
        var pad4 = function(n) { return ('0000' + n).substr(-4); };
        return pad4(date.getFullYear()) + '-' + pad2(date.getMonth() + 1) + '-' + pad2(date.getDate());
    },

    toISOTime: function(string) {
        var date = parseDate(string);
        if (date.toString() == 'Invalid Date') return null;
        var pad2 = function(n) { return ('00' + n).substr(-2); };
        return pad2(date.getHours()) + ':' + pad2(date.getMinutes()) + ':' + pad2(date.getSeconds());
    },

    // formatDate(format:String):String
    formatDate: function(string, format) {
        var date = parseDate(string);
        if (date.toString() == 'Invalid Date') return null;
        var pad2 = function(n) { return ('00' + n).substr(-2); };
        var pad4 = function(n) { return ('0000' + n).substr(-4); };
        var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
        var monthsShort = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        var daysShort = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
        var year = date.getFullYear();
    	var month = date.getMonth();
    	var day = date.getDate();
    	var weekday = date.getDay();
    	var hours = date.getHours();
    	var minutes = date.getMinutes();
    	var seconds = date.getSeconds();
        return format.replace(/([yMdHhmsaA])(\1+)?/g, function(part) {
            switch (part) {
                case 'yyyy': return pad4(year);
                case 'yy': return pad2(year);
                case 'y': return year;
                case 'MMMM': return months[month];
                case 'MMM': return monthsShort[month];
                case 'MM': return pad2(month + 1);
                case 'M': return month + 1;
                case 'dddd': return days[weekday];
                case 'ddd': return daysShort[weekday];
                case 'dd': return pad2(day);
                case 'd': return day;
                case 'HH': return pad2(hours);
                case 'H': return hours;
                case 'hh': return pad2((hours % 12) || 12);
                case 'h': return (hours % 12) || 12;
                case 'mm': return pad2(minutes);
                case 'm': return minutes;
                case 'ss': return pad2(seconds);
                case 's': return seconds;
                case 'a': return hours < 12 ? 'am' : 'pm';
                case 'A': return hours < 12 ? 'AM' : 'PM';
            }

            return part;
        });
    },

    // toTimestamp():Number
    toTimestamp: function(string) {
        var date = parseDate(string);
        if (date.toString() == 'Invalid Date') {
            return null;
        }
        return Math.floor(date.getTime() / 1000);
    }

});

function formatLocalDate(date) {
    var pad2 = function(n) { return ('00' + n).substr(-2); };
    var pad4 = function(n) { return ('0000' + n).substr(-4); };
    return pad4(date.getFullYear()) + '-' + pad2(date.getMonth() + 1) + '-' + pad2(date.getDate()) + ' ' + pad2(date.getHours()) + ':' + pad2(date.getMinutes()) + ':' + pad2(date.getSeconds());
}

function parseDate(string) {
    var d, struct, offset = 0, n = [1,4,5,6,7,10,11];

    string += '';

    if (string.toLowerCase() == 'now') {
        return new Date();
    }

    if ((struct = /^(\d{4}|[+\-]\d{6})(?:-(\d{2})(?:-(\d{2}))?)?(?:[T ](\d{2}):(\d{2})(?::(\d{2})(?:\.(\d{3}))?)?(?:(Z)|([+\-])(\d{2})(?::(\d{2}))?)?)?$/.exec(string))) {
        for (var i = 0, k; (k = n[i]); ++i) {
            struct[k] = +struct[k] || 0;
        }

        struct[2] = (+struct[2] || 1) - 1;
        struct[3] = +struct[3] || 1;

        if (struct[8] === undefined) {
            return new Date(struct[1], struct[2], struct[3], struct[4], struct[5], struct[6], struct[7]);
        } else {
            if (struct[8] !== 'Z' && struct[9] !== undefined) {
                offset = struct[10] * 60 + struct[11];
                if (struct[9] === '+') offset = 0 - offset;
            }

            return new Date(Date.UTC(struct[1], struct[2], struct[3], struct[4], struct[5] + offset, struct[6], struct[7]));
        }
    } else if ((struct = /^(\d{2}):(\d{2})(?::(\d{2}))?$/.exec(string))) {
        var d = new Date();
        d.setHours(+struct[1] || 0);
        d.setMinutes(+struct[2] || 0);
        d.setSeconds(+struct[3] || 0);
        return d;
    }

    return new Date(string);
}

function resetTime(date) {
    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);
    date.setMilliseconds(0);
    return date;
}

})();
